import Vue from "vue";
import VueRouter from "vue-router";
import Account from "../views/Account.vue";
import Case from "../views/Case.vue";
import CaseResult from "../views/CaseResult.vue";
import Confirm from "../views/Confirm.vue";
import FilingOptions from "../views/FilingOptions.vue";
import Forgot from "../views/Forgot.vue";
import Home from "../views/Home.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import TermsUse from "../views/TermsUse.vue";
import Login from "../views/Login.vue";
import Logout from "../views/Logout.vue";
import Page404 from "../views/Page404.vue";
import Page500 from "../views/Page500.vue";
import Payment from "../views/Payment.vue";
import Property from "../views/Property.vue";
import Register from "../views/Register.vue";
import Reset from "../views/Reset.vue";
import Unsubscribed from "../views/Unsubscribed.vue"; // your vuex store
import store from "../store"; // your vuex store
import { USER_REQUEST, TOKEN_DECODE } from "../store/constants";

const noAuthRoute = (to, from, next) => {
	if (!store.getters.isAuthenticated) {
		next();
		return;
	}
	next("/");
};

const authRoute = (to, from, next) => {
	if (store.getters.isAuthenticated) {
		// Dispatching a get user request to validate token
		// on the server
		store.dispatch(USER_REQUEST);
		next();
		return;
	}
	next(`/login?path=${to.fullPath}`);
};
Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: Home,
	},
	{
		path: "/about",
		name: "About",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
	},
	{
		path: "/logout",
		name: "Logout",
		component: Logout,
	},
	{
		path: "/login",
		name: "Login",
		component: Login,
		beforeEnter: noAuthRoute,
	},
	{
		path: "/forgot",
		name: "Forgot",
		component: Forgot,
		beforeEnter: noAuthRoute,
	},
	{
		path: "/reset",
		name: "Reset",
		component: Reset,
		beforeEnter: noAuthRoute,
	},
	{
		path: "/unsubscribed",
		name: "Unsubscribed",
		component: Unsubscribed,
	},
	{
		path: "/register",
		name: "Register",
		component: Register,
	},
	{
		path: "/confirm",
		name: "Confirm",
		component: Confirm,
		beforeEnter: authRoute,
		// props: {
		// 	isConfirmProp: true,
		// },
	},
	{
		path: "/property/:id",
		name: "Property",
		component: Property,
	},
	{
		path: "/file-options/:id",
		name: "Filing Options",
		component: FilingOptions,
	},
	{
		// @TODO ASK do we have to comment out that sec
		path: "/payment/:id",
		name: "Payment",
		component: Payment,
		beforeEnter: authRoute,
	},
	{
		path: "/case/:id",
		name: "Case",
		component: Case,
		beforeEnter: authRoute,
	},
	{
		// @TODO ASK do we have to comment out that sec
		path: "/case-result/:id",
		name: "Case Result",
		component: CaseResult,
		beforeEnter: authRoute,
	},
	{
		path: "/account",
		name: "Account",
		component: Account,
		beforeEnter: authRoute,
	},
	{
		path: "/privacy-policy",
		name: "Privacy Policy",
		component: PrivacyPolicy,
	},
	{
		path: "/terms-use",
		name: "Terms of Use",
		component: TermsUse,
	},
	{
		path: "/404",
		name: "Page404",
		component: Page404,
	},
	{
		path: "/500",
		name: "Page500",
		component: Page500,
	},
	{
		path: "*",
		redirect: "/404",
	},
];

const router = new VueRouter({
	mode: "history",
	routes,
});
// router.beforeEach((to, from, next) => {
// 	store.dispatch(TOKEN_DECODE).then(() => next());
// });
export default router;
